(() => {
  'use strict';
  document.querySelectorAll('[data-ft-collection]').forEach((section) => {
    if (section.dataset.filtersReady) return;
    section.dataset.filtersReady = 'true';
    const form = section.querySelector('[data-ft-filter-form]');
    if (!form) return;
    const groups = [...form.querySelectorAll('[data-ft-filter]')];
    const error = form.querySelector('[data-ft-filter-error]');
    const min = form.querySelector('[data-ft-price-min]');
    const max = form.querySelector('[data-ft-price-max]');
    const clearError = () => { if (error) { error.hidden = true; error.textContent = ''; } };
    groups.forEach((group) => {
      group.addEventListener('toggle', () => {
        if (group.open) groups.forEach((other) => { if (other !== group) other.open = false; });
      });
      group.querySelector('[data-ft-filter-reset]')?.addEventListener('click', () => {
        group.querySelectorAll('input').forEach((input) => {
          if (input.type === 'checkbox') input.checked = false;
          else input.value = '';
        });
        clearError();
        group.querySelector('input:not(:disabled)')?.focus();
      });
    });
    document.addEventListener('click', (event) => {
      groups.forEach((group) => { if (group.open && !group.contains(event.target)) group.open = false; });
    });
    document.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const open = groups.find((group) => group.open);
      if (open) { open.open = false; open.querySelector('summary')?.focus(); }
    });
    form.addEventListener('input', clearError);
    form.addEventListener('submit', (event) => {
      if (min?.value !== '' && max?.value !== '' && Number(min?.value) > Number(max?.value)) {
        event.preventDefault();
        const priceGroup = min.closest('[data-ft-filter]');
        if (priceGroup) priceGroup.open = true;
        if (error) { error.textContent = 'Minimum price must be less than or equal to maximum price.'; error.hidden = false; }
        min.focus();
        return;
      }
      event.preventDefault();
      const url = new URL(form.action, window.location.href);
      const params = new URLSearchParams();
      new FormData(form).forEach((value, name) => { if (String(value).trim() !== '') params.append(name, value); });
      url.search = params.toString();
      window.location.assign(url.toString());
    });
  });
})();
